//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectFaceList.js";
import "../no/SelectEdgeList.js";
import "../no/ScCollector.js";
import "../no/ugmath.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CenterlineLength",1,0],[0,"CircleCenter",1,"Point",0],[0,"DistanceToEdgeMidpoint",1,0],[0,"HoleDepth",1,0],[0,"HoleDiameter",1,0],[1,"ReferenceSketchPlane",0,"SelectFaceList",0],[1,"SelectEdge",0,"SelectEdgeList",0],[0,"SketchOrientation",1,"Direction",1],[1,"SketchPlane",0,"ScCollector",1],[0,"Type",1,0]],[[["sketchPlane","sketchVector","needChangeView"],"CreateWireHoleSketch",{R_:{sketchTag:"TaggedObject"}},3,0],[["sketchTag","circleOrigin"],"CreateWireHole",{R_:{curveTag:"TaggedObject"}},2,0],[["sketchTag"],"DeleteWireHoleSketch",{},1,0],[["sketchTag","curveTag"],"DeleteWireHole",{},2,0],[["bodyTag","referenceNormal"],"FindSketchFaceOnBody",{R_:{faceTag:"TaggedObject"}},2,0],[["sketchTag"],"SynchronizeSketch",{},1,0],[["circleTag"],"UpdateWireHole",{},1,0],[["clearCache"],"SetClearCache",{},1,0],[[],"GetClearCache",{R_:{clearCache:''}},0,0],[["bodyNum"],"SetSynchronizingBodyNum",{},1,0],[[],"GetSynchronizingBodyNum",{R_:{bodyNum:''}},0,0]],[]];
SPLM.Tooling.WireHoleBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.WireHoleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.WireHoleBuilder.Types = Object.freeze({
    "SpecifyPoint" : "SpecifyPoint", "SelectEdge" : "SelectEdge"});

export default SPLM;